// extracted by mini-css-extract-plugin
module.exports = {"textArea":"FeedbackModal_textArea__B855G"};